import { Card, Space, Statistic } from 'antd';
import { round10 } from 'shared/utils/numbers/round';
import { ComparisonValue } from 'components/common/comparison-value';
import styles from './transport-aggregated-load-statistic.module.scss';
import type { ITransportAggregatedLoadStatisticProps } from './types';

export const TransportAggregatedLoadStatistic = (props: ITransportAggregatedLoadStatisticProps) => {
  const { value, comparisonValue } = props;

  const loadDiff = comparisonValue ? round10(value.averageLoad - comparisonValue.averageLoad) : 0;
  const tripsDiff = comparisonValue ? value.numberOfTrips - comparisonValue.numberOfTrips : 0;
  const usefulPointsDiff = comparisonValue
    ? round10(value.averageUsefulPointsCount - comparisonValue.averageUsefulPointsCount)
    : 0;

  return (
    <Space size='middle' className={styles.container}>
      <Card>
        <Statistic title='Average Load' value={value.averageLoad} suffix='%' precision={1} />
        {comparisonValue && loadDiff !== 0 && (
          <ComparisonValue value={round10(comparisonValue.averageLoad)} diff={loadDiff} suffix='%' />
        )}
      </Card>
      <Card>
        <Statistic title='Number of Trips' value={value.numberOfTrips} />
        {comparisonValue && tripsDiff !== 0 && (
          <ComparisonValue value={comparisonValue.numberOfTrips} diff={tripsDiff} />
        )}
      </Card>
      <Card>
        <Statistic title='Average Useful Points' value={value.averageUsefulPointsCount} precision={1} />
        {comparisonValue && usefulPointsDiff !== 0 && (
          <ComparisonValue value={round10(comparisonValue.averageUsefulPointsCount)} diff={usefulPointsDiff} />
        )}
      </Card>
    </Space>
  );
};
